/**
 * Where the cut line is drawn: the index of the item it sits just before
 * (list length = after the last item). Position 0 is a real position (nothing
 * above the line) and must still be drawn, or the line cannot be moved back.
 */
export function cutLineSlot(position: number | null | undefined, itemCount: number): number {
  const p = Number.isFinite(position) ? (position as number) : 0;
  return Math.min(Math.max(Math.trunc(p), 0), Math.max(itemCount, 0));
}

/**
 * Where the cut line is drawn while a filter shows only some members: just
 * before the first shown row that is below the line. `shownPlaces` are the
 * shown rows' 0-based places in the whole pool, in order. The line itself has
 * not moved — this only says where it falls among the rows on screen.
 */
export function cutLineSlotAmong(shownPlaces: number[], position: number | null | undefined): number {
  const p = Number.isFinite(position) ? Math.trunc(position as number) : 0;
  return shownPlaces.filter((place) => place < p).length;
}
